import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-16 md:h-18">
        <Link to="/" className="flex items-center gap-2 shrink-0">
          <div className="w-9 h-9 md:w-10 md:h-10 rounded-lg bg-primary-500 flex items-center justify-center">
            <i className="ri-fire-line text-background-50 text-lg md:text-xl"></i>
          </div>
          <span className="font-heading font-bold text-xl md:text-2xl text-foreground-900 whitespace-nowrap">
            52吃瓜网
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {categories.slice(0, 5).map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`px-3 py-2 text-sm font-medium rounded-lg transition-colors whitespace-nowrap ${
                location.pathname === `/category/${cat.slug}`
                  ? 'text-primary-600 bg-primary-100/80'
                  : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
              }`}
            >
              {cat.name}
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/about"
            className="px-4 py-2 text-sm font-medium text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap"
          >
            关于我们
          </Link>
          <a
            href="#download"
            className="px-5 py-2 text-sm font-semibold bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            APP下载
          </a>
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-4">
          <div className="flex flex-col gap-2">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-3 text-sm font-medium rounded-lg transition-colors ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'text-primary-600 bg-primary-100/80'
                    : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <hr className="border-background-200/70 my-1" />
            <Link
              to="/about"
              className="px-4 py-3 text-sm font-medium text-foreground-600 hover:text-foreground-900 hover:bg-background-100 rounded-lg transition-colors"
            >
              关于我们
            </Link>
            <a
              href="#download"
              className="px-5 py-3 text-sm font-semibold bg-primary-500 text-background-50 rounded-full text-center hover:bg-primary-600 transition-colors cursor-pointer"
            >
              APP下载
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}